import React from 'react';
import SocialLinks from './SocialLinks.tsx';
import ITBLogo from './ITBLogo.tsx';
import MonashLogo from './MonashLogo.tsx';
import ClusterMap from './ClusterMap.tsx';
import ExternalHeader from './ExternalHeader.tsx';

const DesktopExternal: React.FC = () => {
    return (
        <div className='flex justify-center items-center md:flex-row mt-10 mb-10 w-[65.625rem] h-auto'>
            <ClusterMap className='w-64 mr-10 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out' />
            <div className='flex flex-col justify-center items-center md:items-center'>
                <br />
                <ExternalHeader />
                <br />
                <SocialLinks />
                <br />
                <br />
            </div>
            <MonashLogo className='w-64 ml-12 group' />
        </div>
    );
};

export default DesktopExternal;